import React from "react";
import Sidebar from "../../../component/home/sidebar";
import accepted from "../../../assets/img/accepted.jpg";
import { useNavigate } from "react-router-dom";

export default function BillingPlans() {
  const navigate = useNavigate();
  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <div
        className="h-full flex flex-col bg-white md:flex-row"
        style={{ height: "100vh" }}
      >
        <Sidebar />
        <div className="flex-auto p-6">
          <div className="flex justify-center w-full h-32 border-2 pt-5">
            <h1 className="text-xl md:text-xl text-slate-800 font-bold">
              Select a billing cycle
            </h1>
          </div>
          <div className="w-1/2 h-80 -mt-[58px] mx-auto bg-white">
            <div className="border-2">
              <div className="p-4 border-b-2 font-bold">
                Choose a plan you wish to proceed
              </div>
              <div>
                <div className="py-2 px-4">
                  <input type="radio" id="plan1" name="plans" />
                  <label for="plan1" className="ml-2">
                    Buy for 1 month
                  </label>
                  <span className="float-right"> $49.99</span>
                </div>
                <div className="py-2 px-4">
                  <input type="radio" id="plan2" name="plans" />
                  <label for="plan2" className="ml-2">
                    Buy for 3 months
                  </label>
                  <span className="float-right"> $129.99</span>
                </div>
                <div className="py-2 px-4">
                  <input type="radio" id="plan3" name="plans" />
                  <label for="plan3" className="ml-2">
                    Buy for 6 months
                  </label>
                  <span className="float-right"> $249.99</span>
                </div>
                <div className="py-2 px-4">
                  <input type="radio" id="plan4" name="plans" />
                  <label for="plan4" className="ml-2">
                    Buy for 12 months
                  </label>
                  <span className="float-right"> $449.99</span>
                </div>
              </div>
            </div>
            <button
              className="btn flex-auto ml-0 sm:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white my-6 float-right"
              onClick={() => navigate("/billingdetails")}
            >
              Continue to checkout
            </button>
          </div>
          <div className="w-full mt-4 ">
            {" "}
            {/* border-2 */}
            <div>
              <p className="flex justify-center text-xs m-auto">
                Prices do not include applicable taxes, which are determined
                according to your billing address. The final price can be seen
                on the purchase page, before payment is completed.
              </p>
            </div>
          </div>
          <div className="flex justify-around w-1/2 h-80 -mt-[58px] mx-auto bg-white mt-6">
            <div className="w-full">
              <label className="font-bold">ACCEPTED PAYMENT METHODS</label>
              <img src={accepted} width={250} height={100} />
            </div>
            <div className="flex justify-around w-3/4">
              <div>
                <i
                  class="fa-regular fa-shield-check fa-2xl mt-5 mr-1"
                  style={{ color: "#97ff6b" }}
                ></i>
              </div>
              <div>
                <label className="font-bold text-sm">SSL SECURE PAYMENT</label>
                <div>
                  <label className="text-xs">
                    Your information is protected by 256-bit SSL encryption
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
BillingPlans.auth = { path: "/billingplans", role: "super-admin" };
